const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/v2`;

// Type configuration - using i18n for translations
export const getIncidentTypes = (t) => ({
  ruh: { label: 'RUH', fullLabel: t('deviations.types.ruh', 'RUH (Uønsket hendelse)'), color: 'orange', icon: '⚠️' },
  deviation: { label: t('deviations.types.deviation', 'Avvik'), fullLabel: t('deviations.types.deviation', 'Avvik'), color: 'red', icon: '❌' },
  improvement: { label: t('deviations.types.improvement', 'Forbedring'), fullLabel: t('deviations.types.improvement', 'Forbedring'), color: 'blue', icon: '💡' }
});

export const getRuhCategories = (t) => ({
  personal_injury: t('deviations.categories.personal_injury', 'Personskade'),
  near_miss: t('deviations.categories.near_miss', 'Nestenulykke'),
  material_damage: t('deviations.categories.material_damage', 'Materiell skade'),
  dangerous_situation: t('deviations.categories.dangerous_situation', 'Farlig situasjon'),
  environmental: t('deviations.categories.environmental', 'Miljøhendelse'),
  other: t('deviations.categories.other', 'Annet')
});
